module.exports = __webpack_public_path__ + "img/microservices.8d5574af.svg";